.container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 3rem 2rem;
	min-height: 300px;
	text-align: center;
}

.iconWrapper {
	margin-bottom: 1.5rem;
}

.icon {
	width: 64px;
	height: 64px;
	color: #fa5252;
	animation: fadeIn 0.3s ease-in;
}

.title {
	font-size: 1.75rem;
	font-weight: 700;
	margin: 0 0 0.75rem 0;
	color: var(--color-text);
}

.message {
	font-size: 1.1rem;
	color: var(--color-text-secondary);
	margin: 0 0 2rem 0;
	max-width: 500px;
	line-height: 1.6;
}

.retryButton {
	padding: 0.75rem 1.5rem;
	font-size: 1rem;
	font-weight: 600;
	color: #ffffff;
	background: linear-gradient(135deg, #228be6, #1971c2);
	border: none;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.2s ease;
	box-shadow:
		0 2px 8px rgba(34, 139, 230, 0.25),
		0 1px 3px rgba(34, 139, 230, 0.15);

	&:hover {
		background: linear-gradient(135deg, #1971c2, #1864ab);
		transform: translateY(-1px);
		box-shadow:
			0 4px 12px rgba(34, 139, 230, 0.35),
			0 2px 4px rgba(34, 139, 230, 0.2);
	}

	&:active {
		transform: translateY(0);
		box-shadow:
			0 1px 4px rgba(34, 139, 230, 0.2),
			0 1px 2px rgba(34, 139, 230, 0.1);
	}
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: scale(0.8);
	}
	to {
		opacity: 1;
		transform: scale(1);
	}
}

// Dark mode adjustments
@media (prefers-color-scheme: dark) {
	.icon {
		color: #ff6b6b;
	}

	.retryButton {
		background: linear-gradient(135deg, #4dabf7, #339af0);

		&:hover {
			background: linear-gradient(135deg, #339af0, #228be6);
		}
	}
}

// Mobile responsive
@media (max-width: 768px) {
	.container {
		padding: 2rem 1.5rem;
		min-height: 250px;
	}

	.icon {
		width: 48px;
		height: 48px;
	}

	.title {
		font-size: 1.5rem;
	}

	.message {
		font-size: 1rem;
		margin-bottom: 1.5rem;
	}

	.retryButton {
		padding: 0.625rem 1.25rem;
		font-size: 0.95rem;
	}
}
